export default __webpack_public_path__ + "static/media/polygon.b11cc6e9.svg";